// CacheKey 4c8472afdb4564152c47ce4dd4b83f4e
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    rule: {
      add_flag_to_admitted_patients_rule: {
        description: "If a patient has been in a unit for more than X hours, add a rounding flag.",
        hint: "Every time this rule will apply to patients who were admitted to a unit more than X hours ago."
      },
      attempted_with_status_rule: {
        description: "If a patient has been attempted with status X as part of Y Outreach Action",
        hint: "First time this rule will check call attempts triggered within last hour. Every next time this rule will operate with call attempts triggered since the previous rule execution."
      },
      enroll_after_program_rule: {
        description: "If a patient has concluded Outreach Program X then enroll patient in Outreach Program Y",
        hint: "First time this rule will check patients who concluded the specified outreach program within last 24 hours. Every next time this rule will operate with patients who concluded the specified outreach program since the previous rule execution."
      },
      expected_discharge_date_rule: {
        description: "If patient's expected discharge date is within the next X days, add a rounding flag",
        hint: "Every time this rule runs, it will add rounding flag to admitted patients with expected discharge date within the specified amount of upcoming days. If admitted patients are already flagged, but their expected discharge date is out of specified timeframe, the flag will be removed."
      },
      unsuccessful_rule: {
        description: "If a patient is attempted but it's unsuccessful as part of X Outreach Action",
        hint: "First time this rule will check call attempts triggered within last 24 hours. Every next time this rule will operate with call attempts triggered since the previous rule execution. The counter will be restarted each time the rule is matched, hence reporting issues/alerts every N matches of the rule."
      },
      never_rounded_on_patient_rule: {
        description: "If a patient has never been rounded after admitted in a unit for more than X hours, add a rounding flag.",
        hint: "Every time it is run, the flag will apply to patients that were never rounded on and were admitted to a unit for more than x hours ago."
      },
      not_rounded_rule: {
        description: "If a patient hasn't been rounded on in X Hours",
        hint: "Every time this rule will operate with encounters rounded more than X (condition) hours ago."
      },
      no_rounds_in_unit_rule: {
        description: "If a patient has no rounds in unit/facility for the last X hours, add a rounding flag",
        hint: "Every time this rule runs, it will add rounding flag to admitted patients that are currently in the configured unit but are not rounded in this unit for configured amount of time."
      },
      played_echo_rule: {
        description: "If a patient has played a care recording more than X times",
        hint: "First time this rule will check audio instructions that were played within last hour. Every next time this rule will operate with audio instructions that were played since the previous rule execution."
      },
      unadmit_old_arrivals_rule: {
        description: "If a patient has arrived more than X hours ago — remove currently admitted flag",
        hint: "Every time this rule will operate with patients arrived more than X (condition) hours ago."
      },
      unattempted_issue_for_location_rule: {
        description: "If a location has an unattempted issue for X minutes",
        hint: "Every time this rule will operate with issues created more than X (condition) minutes ago."
      },
      unattempted_issue_for_staff_rule: {
        description: "If a staff member has an unattempted issue for X minutes",
        hint: "Every time this rule will operate with issues created more than X (condition) minutes ago."
      },
      unattempted_issue_rule: {
        description: "If a patient has an unattempted issue for X minutes",
        hint: "Every time this rule will operate with issues created more than X (condition) minutes ago."
      },
      unit_visit_rule: {
        description: "If a patient has been transferred from unit X to unit Y",
        hint: "Every time this rule will apply specified flag to patients who were transferred from unit X to unit Y."
      },
      unresolved_issue_for_location_rule: {
        description: "If a location has an unresolved issue for X minutes",
        hint: "Every time this rule will operate with issues created more than X (condition) minutes ago."
      },
      unresolved_issue_for_staff_rule: {
        description: "If a staff member has an unresolved issue for X minutes",
        hint: "Every time this rule will operate with issues created more than X (condition) minutes ago."
      },
      unresolved_issue_rule: {
        description: "If a patient has an unresolved issue for X minutes",
        hint: "Every time this rule will operate with issues created more than X (condition) minutes ago."
      },
      observation_rule: {
        description: "If a patient gets an observation result with name X — create a key metric Y",
        hint: "Every time this rule will operate when observation results with name X are created."
      },
      interaction_without_alerts_or_issues_rule: {
        description: "If a patient has concluded Outreach Action X without Issues or Alerts",
        hint: "Every time this rule will operate when interactions for Outreach Action X are created without any Issue or Alert."
      },
      did_not_reach_last_answer_rule: {
        description: "If a patient did not respond to all questions in Outreach Action X",
        hint: "Every time this rule will check interactions from the last hour where the patient did not respond to all questions in the configured outreach action. You can specify if you want to only include patients that answered first medical, otherwise we ignore this condition and apply the rule for patients who answered first medical or did not answer first medical. You can also specify if you want to include patients that opted out, otherwise we filter them out and do not apply the rule for patients who opted out."
      },
      program_disenrollment_rule: {
        description: "If a patient has been disenrolled from certain Outreach Programs",
        hint: "First time this rule will check call attempts triggered within last hour. Every next time this rule will operate with disenrollment events created since the previous rule execution. If no source is selected, any source will be considered."
      },
      unassign_roundables_by_rounds_rule: {
        description: "If a roundable gets rounded X times, unassign all rounding assignees from it",
        hint: "Every time this rule will operate when a round is performed on the roundable"
      },
      unassign_roundables_by_time_rule: {
        description: "If a roundable assignee has been assigned to a roundable for more than X hours, unassign it",
        hint: "Every time this rule will operate with rounding assignees that were assigned more than X (condition) hours ago"
      },
      update_encounter_after_program_rule: {
        description: "If a patient has concluded Outreach Program X, then update target field on encounter.",
        hint: "First time this rule will check patients who concluded the specified outreach program within last hour. Every next time this rule will operate with outreach programs concluded since the previous rule execution."
      }
    },
    import_rule: {
      implicit_termination_rule: {
        description: "If an Enrollment with Criteria X is not included in an import using Import Association Y then implicitly term the Enrollment",
        hint: "This rule will run after an patient import with this import association is done."
      }
    },
    tagging_rule: {
      multiple_encounter_tagging_rule: {
        description: "If patient has X number of encounters within Y Days"
      },
      enrolled_in_care_management_tagging_rule: {
        description: "If care management enrollment status is currently enrolled add tag X, and if care management enrollment status is disenrolled remove tag X."
      }
    }
  }
}

